import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Building2, User, ArrowRight } from "lucide-react";

const OPTIONS = [
  {
    key: "company",
    Icon: Building2,
    eyebrow: "Option 1",
    label: "Have a company or multiple employees?",
    cta: "Register Company",
    to: "/register-company",
    testId: "choice-company",
    accent: "bg-safety-yellow text-black border-black",
  },
  {
    key: "user",
    Icon: User,
    eyebrow: "Option 2",
    label: "Only want to track your own certifications?",
    cta: "User Creation",
    to: "/signup/user",
    testId: "choice-user",
    accent: "bg-foreground text-background border-foreground dark:border-safety-yellow",
  },
];

export default function RegisterChoice() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-4 md:p-10 grid-bg">
      <div className="w-full max-w-3xl">
        <Link
          to="/"
          data-testid="choice-back"
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider mb-6 hover:text-safety-yellow"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Login
        </Link>

        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 border-2 border-safety-yellow bg-safety-yellow/15 px-3 py-1 mb-3 text-[10px] font-bold uppercase tracking-[0.25em]">
            Get Started
          </div>
          <h1 className="font-heading text-4xl md:text-5xl leading-none">CREATE ACCOUNT</h1>
          <p className="text-sm text-muted-foreground mt-3 max-w-xl">
            Choose the path that fits your situation. You can always link or migrate later.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {OPTIONS.map((o) => (
            <button
              key={o.key}
              type="button"
              data-testid={o.testId}
              onClick={() => navigate(o.to)}
              className="group brutal-card text-left p-6 md:p-7 flex flex-col gap-5 transition-all duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-brutalYellow active:translate-x-0 active:translate-y-0 active:shadow-none"
            >
              <div className="flex items-start justify-between">
                <span className={`inline-flex items-center justify-center h-14 w-14 border-2 ${o.accent}`}>
                  <o.Icon className="w-7 h-7" strokeWidth={2.75} />
                </span>
                <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-muted-foreground">
                  {o.eyebrow}
                </div>
              </div>

              <div className="flex-1">
                <div className="font-heading text-2xl md:text-[26px] leading-tight">
                  {o.label}
                </div>
              </div>

              <div className="inline-flex items-center justify-between border-t-2 border-foreground/10 dark:border-safety-yellow/20 pt-4 text-xs font-black uppercase tracking-wider">
                <span className="text-safety-yellow">{o.cta}</span>
                <ArrowRight
                  className="w-5 h-5 transition-transform duration-150 group-hover:translate-x-1"
                  strokeWidth={3}
                />
              </div>
            </button>
          ))}
        </div>

        <div className="mt-8 text-center text-xs font-bold uppercase tracking-wider text-muted-foreground">
          Already have an account?{" "}
          <Link to="/" className="text-safety-yellow underline decoration-4 underline-offset-2">
            Sign in &rarr;
          </Link>
        </div>
      </div>
    </div>
  );
}
